module.exports = __webpack_public_path__ + "img/button.cc94e359.svg";